<template>
<p style="margin-bottom: 1rem;">
    <label style="font-size:1rem; margin-bottom: 0;" :for="question">{{ question }} <span v-if="answers.length > 0">*</span> <span v-if="display == 'slider'"><small><i>Slide your response</i></small></span></label>
    <template v-if="answers.length > 0 && display == 'select'">
        <select style="color:#0a0a0a;" :id="question" name="question" v-model="answer" @change="emit('response', answer)">
            <option value="">Please choose a response</option>
            <template v-for="option in answers">
                <option :value="option">{{ option }}</option>
            </template>
        </select>
        <p v-if="isError" class="error">Please select an option</p>
    </template>
    <template v-else-if="answers.length > 0 && display == 'slider'">
        <p style="display:flex; justify-content: space-between;">
            <span v-for="(num, i) in answers" style="text-align:center; width:25px;">
                {{ answers.length - i }}
            </span>
        </p>
        <input :id="question" type="range" v-model="answer" min="1" :max="answers.length" class="slider" @change="$emit('response', (answers.length + 1) - answer)">
        <p style="display:flex; justify-content: space-between;"><span :style="answer == 1 ? 'color: #dd8f55' : 'color: #0a0a0a'">{{ answers[0] }}</span><span :style="answer == 5 ? 'color: #dd8f55' : 'color: #0a0a0a'">{{ answers[answers.length - 1] }}</span></p>
        
        <p v-if="isError" class="error">Please select an option</p>
    </template>
    <template v-else>
        <textarea rows="3" v-model="answer"  @change="emit('response', answer)" placeholder="share your comments"></textarea>
    </template>
</p>
</template>

<script setup>
    import { onMounted, ref } from 'vue'
const props = defineProps([ 'question', 'answers', 'isError', 'display' ])
const emit = defineEmits([ 'do-action' ])

    const answer = ref('')
        
    function load(event) {
        if(props.display == 'slider') {
            answer.value = 1;
            emit('response', (props.answers.length + 1) - answer.value);
        }
    }
            
    onMounted(() => {
        load();
    })

</script>

<style type="text/css">
    .slider {
  -webkit-appearance: none;  /* Override default CSS styles */
  appearance: none;
  width: 100%; /* Full-width */
  height: 25px; /* Specified height */
  background: #d3d3d3; /* Grey background */
  outline: none; /* Remove outline */
  opacity: 0.7; /* Set transparency (for mouse-over effects on hover) */
  -webkit-transition: .2s; /* 0.2 seconds transition on hover */
  transition: opacity .2s;
  margin: 0;
}

/* Mouse-over effects */
.slider:hover {
  opacity: 1; /* Fully shown on mouse-over */
}

/* The slider handle (use -webkit- (Chrome, Opera, Safari, Edge) and -moz- (Firefox) to override default look) */
.slider::-webkit-slider-thumb {
  -webkit-appearance: none; /* Override default look */
  appearance: none;
  width: 25px; /* Set a specific slider handle width */
  height: 25px; /* Slider handle height */
  background: #dd8f55; /* Green background */
  cursor: pointer; /* Cursor on hover */
}

.slider::-moz-range-thumb {
  width: 25px; /* Set a specific slider handle width */
  height: 25px; /* Slider handle height */
  background: #dd8f55; /* Green background */
  cursor: pointer; /* Cursor on hover */
}
</style>